import WriterEditor from '../../routes/WriterEditor';
import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { articlePayloadAtom } from '../../components/CreateArticle/atom';
import { initialStateArticle } from '../../components/CreateArticle/atom/initialState';
import {
  contributorAtom,
  hashtagAtom
} from '../../components/Common/Form/textarea-custom-hook-form/atom';
import useParsedQueryString from '../../hooks/router/useParsedQueryString';
import SEO from '../../components/SEO';
import { generateSEOMetadata, dynamicPages } from '../../utils/seo';

const CreateArticle = () => {
  const [, setArticlePayload] = useAtom(articlePayloadAtom);
  const [, setContributors] = useAtom(contributorAtom);
  const [, setHashtag] = useAtom(hashtagAtom);

  // Get query parameters
  const queryParams = useParsedQueryString();
  const storyId = queryParams.storyId;

  // Reset article state when creating a new article
  // Reset on mount and when storyId changes to ensure clean state
  useEffect(() => {
    setArticlePayload({
      ...initialStateArticle,
      // Pre-populate with storyId if provided (for Story Pulse integration)
      ...(storyId && { storyId })
    });
    setContributors([]);
    setHashtag([]);
  }, [storyId, setArticlePayload, setContributors, setHashtag]);

  // Generate SEO metadata for create article page
  const seoMetadata = generateSEOMetadata.dynamicPage(
    dynamicPages['article/create'].name,
    dynamicPages['article/create'].url,
    dynamicPages['article/create'].description
  );

  return (
    <div>
      <SEO {...seoMetadata} />
      <WriterEditor />
    </div>
  );
};

export default CreateArticle;
